import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isBrowser as K } from "../../_utils/env/is-browser.js";
import { computed as T } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function B(t) {
  return T(() => t.leafOnly ? "child" : t.checkStrategy);
}
function I(t, o) {
  return !!t.rawNode[o];
}
function S(t, o, n, s) {
  t == null || t.forEach((e) => {
    n(e), S(e[o], o, n, s), s(e);
  });
}
function x(t, o, n, s, e) {
  const r = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), a = [];
  return S(t, s, (p) => {
    if (a.push(p), e(o, p)) {
      u.add(p[n]);
      for (let f = a.length - 2; f >= 0; --f)
        if (!r.has(a[f][n]))
          r.add(a[f][n]);
        else
          return;
    }
  }, () => {
    a.pop();
  }), {
    expandedKeys: Array.from(r),
    highlightKeySet: u
  };
}
if (K && Image) {
  const t = new Image();
  t.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
}
function C(t, o, n, s, e) {
  const r = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), p = [], f = [], g = [];
  function l(d) {
    d.forEach((i) => {
      if (g.push(i), o(n, i)) {
        r.add(i[s]), a.add(i[s]);
        for (let h = g.length - 2; h >= 0; --h) {
          const A = g[h][s];
          if (!u.has(A))
            u.add(A), r.has(A) && r.delete(A);
          else
            break;
        }
      }
      const c = i[e];
      c && l(c), g.pop();
    });
  }
  l(t);
  function m(d, i) {
    d.forEach((c) => {
      const h = c[s], A = r.has(h), E = u.has(h);
      if (!A && !E)
        return;
      const y = c[e];
      if (y)
        if (A)
          i.push(c);
        else {
          p.push(h);
          const w = Object.assign(Object.assign({}, c), {
            [e]: []
          });
          i.push(w), m(y, w[e]);
        }
      else
        i.push(c);
    });
  }
  return m(t, f), {
    filteredTree: f,
    highlightKeySet: a,
    expandedKeys: p
  };
}
export {
  C as filterTree,
  I as isNodeDisabled,
  x as keysWithFilter,
  B as useMergedCheckStrategy
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/utils.js
// module id = 941
// module chunks = 41